import wizardStyle from "@/src/components/Form/wizardStyle";

const administrativeDecisionFeedbackFormStyle = {
  ...wizardStyle,
  button: {
    margin: "1rem 0",
  },
};
export default administrativeDecisionFeedbackFormStyle;
